import $http from '../assets/js/http'

export function getList (params, enableLoading = true) {
  $http.custom(params, {moduleId: '1101', enableLoading: enableLoading})
  return $http.post('/plan/query/list', params)
}

export default {
  getList
}



// WEBPACK FOOTER //
// ./src/api/putPlan.js